import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetChatMessageHistory } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (ticketno) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl2 + '/helpdesk-getticketdetail';

    let formdata = new FormData();
    formdata.append("ticket-no",ticketno)
    const argument = {  
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body: formdata
    };  

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS(await response.json());
        data = fromJS(data.get('data'));
        var chat = fromJS({});
        chat = chat.set(ticketno, data);
        data = chat;
    }

    dispatch({ type: GetChatMessageHistory, chat: data });
};